export default __webpack_public_path__ + "static/media/background.9aaa0d9b.jpg";